<mat-icon class="icon-bullet-point">
    {{ icon }}
</mat-icon>
